import { FC } from 'react'
import { Form } from 'react-bootstrap'
import { ReadOnlyFieldProps } from '../../Forms.d'

const ReadOnlyTextField: FC<ReadOnlyFieldProps> = ({
    id,
    label = '',
    showLabel = true,
    name,
    placeholder = '',
    groupClassName = '',
    disabled = false,
    readonly = false,
    type,
    value,
}) => {
    return (
        <Form.Group
            className={(groupClassName || '') + ' sfy-field mb-3'}
            controlId={id}
        >
            {showLabel && <Form.Label>{label}</Form.Label>}
            <Form.Control
                type={type || 'text'}
                name={name}
                value={value}
                onChange={() => {}}
                placeholder={placeholder}
                className="readonly"
                disabled={disabled}
                readOnly={readonly}
                autoComplete={name + '-' + new Date().getMilliseconds()}
            />
            <span className="bottom-border"></span>
        </Form.Group>
    )
}

export default ReadOnlyTextField
